import { createGlobalState } from '@vueuse/core';
import type { FeatureName, FeatureFlags } from '~/types/feature.types';

export const useFeatureStore = createGlobalState(
  () => {
    const state = reactive<{
      features: FeatureFlags;
    }>({
      features: {},
    });

    const features = computed(() => state.features);

    const isEnabled = (featureName: FeatureName): boolean => {
      return !!state.features[featureName];
    };

    const updateFeatures = async () => {
      try {
        const response = await useAuthenticatedFetch<FeatureFlags>('/api/auth/user/features');
        if (response.data.value) {
          state.features = response.data.value;
        }
      } catch (error) {
        console.error('Failed to fetch user features:', error);
      }
    };

    return {
      features,
      isEnabled,
      updateFeatures,
    };
  },
);